import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationWorkingTimeState } from '../reducers/base-location-working-time.reducer';

const getLocationWorkingTimeState = createFeatureSelector<LocationWorkingTimeState>('locationWorkingTime');

export const getDutyModels = createSelector(getLocationWorkingTimeState, (state) => state.dutyModels);
export const getDutyModelCrud = createSelector(getLocationWorkingTimeState, (state) => state.dutyModelCrud);
export const getBreakRules = createSelector(getLocationWorkingTimeState, (state) => state.breakRules);
export const getBreakRuleCrud = createSelector(getLocationWorkingTimeState, (state) => state.breakRuleCrud);
export const getRoundingRules = createSelector(getLocationWorkingTimeState, (state) => state.roundingRules);
export const getRoundingRuleCrud = createSelector(getLocationWorkingTimeState, (state) => state.roundingRuleCrud);
